module.exports = __webpack_public_path__ + "img/passo03@2x.136a9695.png";